import { Button, Loading } from 'components'
import { useConfirmation } from 'hooks/useConfirmation'
import { useCallback, useState } from 'react'
import { noop } from 'utils'
import getLocalized from 'i18n'
import { useUsersActions } from 'providers'
const localized = getLocalized()

export type ReinstateBtnProps = {
  userId: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}
export const ReinstateBtn = ({
  disabled = false,
  userId,
  onDone = noop,
  onError = noop,
}: ReinstateBtnProps) => {
  const {
    account: { reinstate },
  } = useUsersActions()
  const [loading, setLoading] = useState<boolean>(false)

  const confirmClick = useConfirmation({
    header: localized.confirmationModal.reinstate.header,
    body: localized.confirmationModal.reinstate.body,
    confirmText: localized.confirmationModal.reinstate.confirmText,
  })

  const reinstateUser = useCallback(async () => {
    if (await confirmClick()) {
      setLoading(true)
      await reinstate({ userId })
        .then(() => {
          onDone('User has been reinstated')
        })
        .catch(() => {
          onError('Failed reinstating user, please try again')
        })
      setLoading(false)
    }
  }, [userId, reinstate, confirmClick, onDone, onError, setLoading])

  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled || loading}
      onClick={reinstateUser}>
      {loading ? <Loading /> : <span>Reinstate student</span>}
    </Button>
  )
}
